export default __webpack_public_path__ + "static/media/s-ramseiers-wei-go-grase.b9fed2cb.webp";